import React from "react";
import { render } from "react-dom";
import CookiePlaceholder from "./CookiePlaceholder";

(() => {
  const embedContainers = document.querySelectorAll("[data-embed-container]");

  const createExecutableScript = (script) => {
    const executableScript = document.createElement("script");

    [...script.attributes].forEach((attribute) => {
      executableScript.setAttribute(attribute.name, attribute.value);
    });

    executableScript.text = script.text;

    return executableScript;
  };

  const YOUTUBE_IFRAME_SELECTOR =
    'iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[data-src*="youtube"], iframe[data-src*="youtu.be"]';

  const getYoutubeAspectRatio = (iframe) => {
    const width = parseFloat(iframe.getAttribute("width"));
    const height = parseFloat(iframe.getAttribute("height"));

    if (width > 0 && height > 0) {
      return `${width} / ${height}`;
    }

    return "16 / 9";
  };

  const applyYoutubeAspectRatio = (root) => {
    root.querySelectorAll(YOUTUBE_IFRAME_SELECTOR).forEach((iframe) => {
      iframe.style.setProperty(
        "--youtube-aspect-ratio",
        getYoutubeAspectRatio(iframe)
      );
    });
  };

  const setHtmlContent = (container, htmlContent) => {
    const template = document.createElement("template");
    template.innerHTML = htmlContent;

    template.content.querySelectorAll("script").forEach((script) => {
      script.replaceWith(createExecutableScript(script));
    });

    applyYoutubeAspectRatio(template.content);
    container.appendChild(template.content);
  };

  const handleConsent = (container) => {
    if (container.classList.contains("embed-container--clevercast")) {
      return;
    }

    // Clear existing content
    container.innerHTML = "";

    if (!window.Cookiebot) {
      return;
    }

    if (window.Cookiebot.consent.marketing) {
      const htmlContent = container.getAttribute("data-html-content");
      setHtmlContent(container, htmlContent);

      const script = document.createElement("script");
      script.src = "https://www.tiktok.com/embed.js";
      script.async = true;
      document.body.appendChild(script);
    } else {
      const placeholder = document.createElement("div");
      placeholder.setAttribute("data-cookiebot-marketing-placeholder", "");
      container.appendChild(placeholder);
      render(<CookiePlaceholder />, placeholder);
    }
  };

  if (embedContainers) {
    [...embedContainers].forEach(handleConsent);
  }

  window.addEventListener("CookiebotOnAccept", () => {
    if (embedContainers) {
      [...embedContainers].forEach(handleConsent);
    }
  });

  window.addEventListener("CookiebotOnDecline", () => {
    if (embedContainers) {
      [...embedContainers].forEach(handleConsent);
    }
  });
})();
